import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface DiscountPayload {
  excludedClasses: Array<string>;
  isActive: boolean;
  type: string;
  byStudent?: Record<string, number>;
  flat?: number;
  amountByStudent?: Record<string, number>;
  discounts?: Record<string, number>;
  discountRules: string;
  category: string;
  action: 'create' | 'update';
}

const createOrUpdateDiscount = async (payload: DiscountPayload) => {
  const { action, ...discountData } = payload;

  await baseAPI.patch('/discount/rules', {
    discountRules: payload.discountRules,
  });

  if (action === 'create') {
    // Create new discount
    const { data } = await baseAPI.post<DiscountPayload>(
      '/discount',
      discountData,
    );
    return data;
  } else {
    // Update existing discount
    const { data } = await baseAPI.patch<DiscountPayload>(
      '/discount',
      discountData,
    );
    return data;
  }
};

export const useCreateOrUpdateDiscount = () => {
  return useMutation({
    mutationFn: createOrUpdateDiscount,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.DISCOUNT],
      });
      toast.success('Discount updated successfully');
    },
    onError: () => {
      toast.error('Error saving discount settings');
    },
  });
};
